import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: 0,
    border: 'none',
    background: 'none',
    font: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.colorPalette.orange_50}`,
      outlineOffset: 2
    }
  },
  icon: {
    flexShrink: 0,
    width: 24,
    height: 24
  }
}));
